module.exports = __webpack_public_path__ + "tiny treasureshi res resized.jpg?181b621b82c87aeaec772e035ce28aca";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/tiny treasureshi res resized.jpg
// module id = 43
// module chunks = 0